import { Inject, Injectable } from '@angular/core';
import { DfsGlobalsService } from '../../core/dfs-globals.service';
import { NDfs } from '../../dfs.interfaces';

export interface IDfsConfigParserOptions {
    source: string;
}

@Injectable({
    providedIn: 'any'
})
export class DfsConfigParserService implements NDfs.IParser {
    /**
     * Dependencies
     */
    constructor(@Inject(NDfs.OPTIONS) private dfsOptions: NDfs.IOptions) {}

    /**
     * Returns the value from string
     */
    parse(dfsGlobalsService: DfsGlobalsService, dfs: string, rule: NDfs.IParserRule): NDfs.ICssEntry[] {
        const parserOptions = rule.parserOptions as IDfsConfigParserOptions;
        return [
            {
                prop: rule.prop,
                value: `var(${dfsGlobalsService.getVar(parserOptions.source, dfs)})`
            }
        ];
    }
}
